import React, { useEffect, useState } from 'react';

import { useAuth } from '../../providers';
import { SignedInSubscription } from './SignedInSubscription';
import { SignUpAndSubscribe } from './SignUpAndSubscribe';
import { GeneralSubscriptionProps } from './types';

export const GeneralSubscription: React.FC<GeneralSubscriptionProps> = (
  props,
) => {
  const { isLoggedIn } = useAuth();
  const [client, setClient] = useState(false);

  useEffect(() => {
    setClient(true);
  }, []);

  if (!client) return null;

  return isLoggedIn ? (
    <SignedInSubscription {...props} />
  ) : (
    <SignUpAndSubscribe {...props} />
  );
};
